import React, { useState } from "react";
import { Spinner, Button } from "react-bootstrap";

function ReportDetails({ data }) {
  const [isLoading, setIsLoading] = useState(false);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      <ul className="list-unstyled">
        <li className="mt-1 mb-4">
          <strong className="text-black me-2">Remarks:</strong>{" "}
          {data?.remarks || ""}
        </li>
      </ul>

      <h5 className="fw-bold">Checklists</h5>
      <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
        <table
          id="employees-tblwrapper"
          className="table ItemsCheckboxSec dataTable no-footer mb-0"
        >
          <thead>
            <tr>
              <th>Parameter</th>
              <th>Expected Val</th>
              <th>Actual Val</th>
              <th>Evidence File</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data?.checklists) && data?.checklists?.length > 0 ? (
              data.checklists.map((item, index) => (
                <tr key={index}>
                  <td>{item?.parameter?.parameter_name}</td>
                  <td>{item?.parameter?.expected_value}</td>
                  <td>{item?.actual_value}</td>
                  <td>
                    {item?.evidence_file ? (
                      <Button
                        variant="info"
                        className="btn-sm"
                        href={`${process.env.REACT_APP_BASE_URL}${item?.evidence_file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-solid fa-file-arrow-down me-2"></i>
                        View File
                      </Button>
                    ) : (
                      "No file"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center p-5">
                  <i class="fas fa-check-square text-primary"></i>  Report not available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ReportDetails;
